import { getAbs } from '../../../utils'
import { checkCardInFilters } from '../../../../helpers/helpers'

export const getShortActionName = (action, raiseIndex, isAllIn) => {
	if (action.includes('Call')) {
		return 'Call'
	}

	if (action.includes('Check') || action.includes('Fold')) {
		return action
	}

	if (isAllIn) {
		return 'All In'
	}

	if (action.includes('R')) {
		return `R#${raiseIndex + 1}`
	}

	if (raiseIndex !== -1 && action.includes('B')) {
		return `B#${raiseIndex + 1}`
	}
}

export const getMultiStackTooltipData = (
	strategies,
	actionValues,
	filter,
	uniqCards,
	threshold,
	s1,
	s2,
	isPositions,
	isRake,
	isOpenRaise
) => {
	let tooltipData = []
	let cardCountAll = 0

	for (let i = 0; i < strategies?.length; i++) {
		let stackValues = strategies[i]

		if (
			!stackValues ||
			stackValues.every((item) => !item) ||
			stackValues.find((item) => item && item.cards.c.length === 0)
		) {
			continue
		}

		const validAction = stackValues.find((item) => item)

		const stack = validAction.stack
		const position = validAction.position
		const rake = validAction.rake
		const openRaise = validAction.openRaise

		let combos = 0
		let eq = 0
		let evAvg = 0
		let played = 0

		let cardCount = 0
		let actionsCount = 0

		let actionsPercents = {}

		for (let x = 0; x < stackValues.length; x++) {
			if (!stackValues[x]) {
				actionsPercents[actionValues[x]?.action] = '--'
				continue
			}

			actionsCount += 1

			let actionIndex = actionValues.findIndex((item) => item.id === stackValues[x].id)

			let pl = 0
			let actionAbs = 0

			for (let j = 0; j < stackValues[x]?.cards.c.length; j++) {
				const card = stackValues[x]?.cards.c[j]

				const isCardInFilter = checkCardInFilters(card, filter.combos, filter.draws, filter.suits, threshold)

				if (s1 && s2) {
					if (card.s[1] === s1 && card.s[3] === s2 && isCardInFilter) {
						cardCountAll++
						cardCount++

						pl += card.val * card.abs
						eq += card.eq
						evAvg += card.ev
						played += card.abs

						uniqCards.add(card.s)

						combos += card.abs

						actionAbs += card.abs
					}
				} else if (isCardInFilter) {
					cardCountAll++
					cardCount++

					uniqCards.add(card.s)

					pl += card.val * card.abs
					eq += card.eq
					evAvg += card.ev
					played += card.abs

					combos += card.abs
					actionAbs += card.abs
				}
			}

			if (cardCount === 0) {
				actionsPercents[actionValues[actionIndex]?.action] = '---'
				continue
			}

			if (!isNaN(pl)) {
				actionsPercents[actionValues[actionIndex]?.action] = ((pl / actionAbs) * 100).toFixed(2)
			}
		}

		combos /= actionsCount

		const abs = cardCount === 0 ? '0.00' : (played / cardCount).toFixed(2)
		const ev = cardCount === 0 ? '0.00' : ((evAvg / cardCount / 100) * 100).toFixed(2)
		const equity = cardCount === 0 ? '0.00' : ((eq / cardCount / 100) * 100).toFixed(2)

		let dynamicProperty = 'Stack'
		let dynamicPropValue = stack

		if (isPositions) {
			dynamicProperty = 'Position'
			dynamicPropValue = position
		}
		if (isRake) {
			dynamicProperty = 'Rake'
			dynamicPropValue = rake
		}
		if (isOpenRaise) {
			dynamicProperty = 'Open raise'
			dynamicPropValue = openRaise
		}

		let stackData = {
			[dynamicProperty]: dynamicPropValue,
			Combos: combos.toFixed(2),
			Abs: abs,
			EV: ev,
			Equity: equity,
			...actionsPercents,
		}

		tooltipData.push(stackData)
	}

	return [tooltipData, cardCountAll]
}

export const getMatrixDataOneStack = (prepareData) => {
	return prepareData.reduce((accumulator, current) => {
		if (prepareData.length === 1) {
			return current.map((row) =>
				row.map((cell) => {
					if (cell.isHidden) {
						return cell
					}

					cell.strategy = [cell.vals]
					cell.fieldMatrixs = [cell.matrixFields]

					return cell
				})
			)
		}
	}, [])
}

export const getMatrixDataMultiStack = (prepareData) => {
	return prepareData.reduce((accumulator, current, index) => {
		return accumulator.map((row, i) =>
			row.map((cell, y) => {
				if (cell.isHidden && !current[i][y].isHidden) {
					let fakeStrategy = Array.from(Array(index), () => null)

					current[i][y].strategy = [...fakeStrategy, current[i][y].vals]
					current[i][y].fieldMatrixs = [...fakeStrategy, current[i][y].matrixFields]

					return current[i][y]
				}

				if (cell.isHidden && current[i][y].isHidden) {
					return cell
				}

				if (!cell.isHidden && current[i][y].isHidden) {
					if (cell.strategy) {
						cell.strategy = [...cell.strategy, null]
						cell.fieldMatrixs = [...cell.fieldMatrixs, null]

						return cell
					}

					cell.strategy = [cell.vals, null]
					cell.fieldMatrixs = [cell.matrixFields, null]

					return cell
				}

				if (cell.strategy) {
					cell.strategy = [...cell.strategy, current[i][y].vals]
					cell.fieldMatrixs = [...cell.fieldMatrixs, current[i][y].matrixFields]

					return cell
				}

				cell.strategy = [cell.vals, current[i][y].vals]
				cell.fieldMatrixs = [cell.matrixFields, current[i][y].matrixFields]

				return cell
			})
		)
	})
}

const getRectCanvas = (vals, filter, threshold, weight, absMatrixMax, getColor) => {
	let [abs, sum] = getAbs(true, vals, weight, filter, threshold, absMatrixMax)

	let rectArray = []

	let offset = 0
	let index = 0

	vals?.forEach((action, iterator) => {
		if (!action) {
			return
		}

		// get the sum of %
		let a_sum = 0.0
		let action_abs = 0.0

		action.cards.c.forEach((card) => {
			const holeSuit = card.s[1] + card.s[3]
			const checkCombo = filter.combos.includes(card.com)
			const checkDraw = filter.draws.includes(card.draw)
			const checkSuits = filter.suits.includes(holeSuit)

			if (checkCombo && checkDraw && checkSuits && card.abs > threshold) {
				a_sum += card.val * card.abs
				action_abs += card.abs
			}
		})

		// if there is nothing to draw
		if (sum === 0) {
			return ''
		}

		// normalize to sum
		a_sum /= action_abs
		const x = 100 * a_sum
		const color = getColor(action.action, action.raiseIndex, action.isAllIn)

		rectArray.push({
			x: offset * abs,
			y: 0,
			width: x * abs,
			fill: color,
			key: iterator,
		})
		offset += x

		index += 1
	})

	return rectArray
}

export const drawCanvasCell = (
	index,
	strategy,
	threshold,
	weight,
	fieldMatrixs,
	getColor,
	filter,
	isDrawReverseActions,
	matrixId,
	text
) => {
	const cellIndex = document.getElementById(`matrix${matrixId}_cell${index}`)

	if (cellIndex) {
		const scale = 5
		cellIndex.width = 100 * scale
		cellIndex.height = 50 * scale

		let cell = cellIndex.getContext('2d')
		let cellHeight = cellIndex.height / strategy.length

		cell.clearRect(0, 0, cellIndex.width, cellIndex.height)

		for (let i = 0; i < strategy.length; i++) {
			const stackData = isDrawReverseActions ? strategy[i]?.slice().reverse() : strategy[i]

			const canvasRectanglesData = getRectCanvas(
				stackData,
				filter,
				threshold,
				weight,
				fieldMatrixs[i]?.absMatrixMax,
				getColor
			)

			if (canvasRectanglesData.length === 0) {
				cell.fillStyle = 'transparent'
				cell.fillRect(0, i * cellHeight, cellIndex.width * scale, cellHeight * scale)

				continue
			}

			for (let j = 0; j < canvasRectanglesData.length; j++) {
				let singleCanvasRectangle = canvasRectanglesData[j]

				if (singleCanvasRectangle) {
					cell.fillStyle = singleCanvasRectangle.fill

					cell.fillRect(
						singleCanvasRectangle.x * scale,
						i * cellHeight,
						singleCanvasRectangle.width * scale,
						cellHeight + 1
					)
				}
			}
		}
	}

	return null
}

export const getSelectedCell = (
	matrixData,
	currentMatrixStack,
	selectedCell,
	zeroArr,
	currentPosition,
	currentRake,
	currentOpenRaise
) => {
	const stack = matrixData[0][0].stack
	const position = matrixData[0][0].position
	const rake = matrixData[0][0].rake
	const openRaise = matrixData[0][0].openRaise

	let selected = zeroArr

	if (
		stack === currentMatrixStack ||
		position === currentPosition ||
		rake === currentRake ||
		openRaise === currentOpenRaise
	) {
		selected = selectedCell
	}

	return {
		stack,
		selected,
		position,
		rake,
		openRaise,
	}
}
